import * as types from './actionTypes';

export const login = (data) =>{
  return{
    type: types.LOGIN_REQUEST,
    data: data
  }
};
export const loginSuccess = () =>{
  return{
    type: types.LOGIN_SUCCESS,
  }
};
export const loginFailure = () =>{
  return{
    type: types.LOGIN_FAILURE,
  }
};

export const forget = (data)=>{
  return{
    type: types.FORGET_REQUEST,
    data: data
  }
};
export const forgetSuccess = () =>{
  return{
    type: types.FORGET_SUCCESS,
  }
};
export const forgetFailure = () =>{
  return{
    type: types.FORGET_FAILURE,
  }
};

export const register = (data) =>{
  return{
    type: types.REGISTER_REQUEST,
    data: data
  }
};
export const registerSuccess = () =>{
  return{
    type: types.REGISTER_SUCCESS,
  }
};
export const registerFailure = () =>{
  return{
    type: types.REGISTER_FAILURE,
  }
};

export const referenceCode = (data) =>{
  return{
    type: types.REFERENCE_CODE_REQUEST,
    data: data
  }
};
export const referenceCodeSuccess = (message) =>{
  return{
    type: types.REFERENCE_CODE_SUCCESS,
    payload:message
  }
};
export const referenceCodeFailure = (message) =>{
  return{
    type: types.REFERENCE_CODE_FAILURE,
    payload:message
  }
};

export const resetPassword = (data) =>{
  return{
    type: types.RESET_PASSWORD_REQUEST,
    data: data
  }
};
export const resetPasswordSuccess = () =>{
  return{
    type: types.RESET_PASSWORD_SUCCESS,
  }
};
export const resetPasswordFailure = () =>{
  return{
    type: types.RESET_PASSWORD_FAILURE,
  }
};

export const verify = (data) =>{
  return{
    type: types.VERIFY_REQUEST,
    data: data
  }
};
export const verifySuccess = () =>{
  return{
    type: types.VERIFY_SUCCESS,
  }
};
export const verifyFailure = () =>{
  return{
    type: types.VERIFY_FAILURE,
  }
};

export const forgetVerify = (data) =>{
  return {
    type: types.FORGET_VERIFY_REQUEST,
    data: data
  }
};
export const forgetVerifySuccess = () =>{
  return{
    type: types.FORGET_VERIFY_SUCCESS,
  }
};
export const forgetVerifyFailure = () =>{
  return{
    type: types.FORGET_VERIFY_FAILURE,
  }
};

export const updateInfo = (data) => {
  return {
    type: types.UPDATE_INFO_REQUEST,
    data: data
  }
};
export const updateInfoSuccess = (data) => {
  return{
    type: types.UPDATE_INFO_SUCCESS,
    payLoad: data
  }
};
export const updateInfoFailure = () => {
  return{
    type: types.UPDATE_INFO_FAILURE,
  }
};

export const changePassword = (data) =>{
  return{
    type: types.CHANGE_PASSWORD_REQUEST,
    data: data
  }
};
export const changePasswordSuccess = () =>{
  return{
    type: types.CHANGE_PASSWORD_SUCCESS,
  }
};
export const changePasswordFailure = () =>{
  return{
    type: types.CHANGE_PASSWORD_FAILURE,
  }
};